if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (cartNotification) {
          cartNotification.setActiveElement(this.openedBy);
        }

        this.modalContent.innerHTML = '';

        if (preventFocus) {
          this.openedBy = null;
        }

        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');

        const openerSpinner =
          opener.querySelector('.loading__spinner');

        if (openerSpinner) {
          openerSpinner.classList.remove('hidden');
        }

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML =
              new DOMParser().parseFromString(
                responseText,
                'text/html'
              );
this.productElement =
  responseHTML.querySelector(
    'section[id^="MainProduct-"]'
  );

if (!this.productElement) {
  throw new Error(
    'Impossible de charger le produit.'
  );
}

const templateSuffix =
  document.body.dataset.templateSuffix;

const isTargetCollection =
  document.body.dataset.templateName === 'collection' &&
  ['biere', 'vin', 'spirit'].includes(templateSuffix);

if (isTargetCollection) {
  this.productElement
    .querySelectorAll('[data-process-addon]')
    .forEach((addon) => addon.remove());
}

this.productElement.classList.forEach(
  (classApplied) => {
    if (
      classApplied.startsWith('color-') ||
      classApplied === 'gradient'
    ) {
      this.modalContent.classList.add(
        classApplied
      );
    }
  }
);

this.preventDuplicatedIDs();
this.removeDOMElements();

this.setInnerHTML(
  this.modalContent,
  this.productElement.innerHTML
);

            /*
             * Transmet l’information Private Reserve
             * de la carte produit vers le formulaire
             * chargé dans la fenêtre Quick Add.
             */
            const modalProductForms =
              this.modalContent.querySelectorAll(
                'product-form'
              );

            modalProductForms.forEach(
              (modalProductForm) => {
                modalProductForm.dataset.privateReserve =
                  opener.dataset.privateReserve ||
                  'false';
              }
            );

            if (
              window.Shopify &&
              Shopify.PaymentButton
            ) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();

            super.show(opener);
          })
          .catch((error) => {
            console.error(
              'Erreur Quick Add :',
              error
            );
          })
          .finally(() => {
            opener.removeAttribute(
              'aria-disabled'
            );

            opener.classList.remove('loading');

            if (openerSpinner) {
              openerSpinner.classList.add(
                'hidden'
              );
            }
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        /*
         * Réinjecte les balises script afin qu’elles
         * puissent s’exécuter après innerHTML.
         */
        element
          .querySelectorAll('script')
          .forEach((oldScriptTag) => {
            const newScriptTag =
              document.createElement('script');

            Array.from(
              oldScriptTag.attributes
            ).forEach((attribute) => {
              newScriptTag.setAttribute(
                attribute.name,
                attribute.value
              );
            });

            newScriptTag.appendChild(
              document.createTextNode(
                oldScriptTag.innerHTML
              )
            );

            oldScriptTag.parentNode.replaceChild(
              newScriptTag,
              oldScriptTag
            );
          });
      }

      preventVariantURLSwitching() {
        const variantPicker =
          this.modalContent.querySelector(
            'variant-selects'
          );

        if (!variantPicker) {
          return;
        }

        variantPicker.setAttribute(
          'data-update-url',
          'false'
        );
      }

      removeDOMElements() {
        const productModal =
          this.productElement.querySelector(
            'product-modal'
          );

        if (productModal) {
          productModal.remove();
        }

        const modalDialogs =
          this.productElement.querySelectorAll(
            'modal-dialog'
          );

        modalDialogs.forEach((modal) => {
          modal.remove();
        });
      }

      preventDuplicatedIDs() {
        const sectionId =
          this.productElement.dataset.section;

        if (!sectionId) {
          return;
        }

        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );

        this.productElement
          .querySelectorAll(
            'variant-selects, product-info'
          )
          .forEach((element) => {
            element.dataset.originalSection =
              sectionId;
          });
      }

      removeGalleryListSemantic() {
        const galleryList =
          this.modalContent.querySelector(
            '[id^="Slider-Gallery"]'
          );

        if (!galleryList) {
          return;
        }

        galleryList.setAttribute(
          'role',
          'presentation'
        );

        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => {
            li.setAttribute(
              'role',
              'presentation'
            );
          });
      }

      updateImageSizes() {
        const product =
          this.modalContent.querySelector(
            '.product'
          );

        if (!product) {
          return;
        }

        const desktopColumns =
          product.classList.contains(
            'product--columns'
          );

        if (!desktopColumns) {
          return;
        }

        const mediaImages =
          product.querySelectorAll(
            '.product__media img'
          );

        if (!mediaImages.length) {
          return;
        }

        let mediaImageSizes =
          '(min-width: 1000px) 715px, ' +
          '(min-width: 750px) calc((100vw - 11.5rem) / 2), ' +
          'calc(100vw - 4rem)';

        if (
          product.classList.contains(
            'product--medium'
          )
        ) {
          mediaImageSizes =
            mediaImageSizes.replace(
              '715px',
              '605px'
            );
        } else if (
          product.classList.contains(
            'product--small'
          )
        ) {
          mediaImageSizes =
            mediaImageSizes.replace(
              '715px',
              '495px'
            );
        }

        mediaImages.forEach((img) => {
          img.setAttribute(
            'sizes',
            mediaImageSizes
          );
        });
      }
    }
  );
}